import { axios } from '../../../util/axios'
import lastLoginStorage from '../../../util/lastLoginStorage'
import platform from '../../../util/platform'

const API_V3_ENDPOINT = '/v3/facebook'
const API_V4_ENDPOINT = '/v4/facebook'

export const facebookLoginApi = (accessToken, email, nickname, sessionTokens, abTests) => {
  if (sessionTokens) sessionTokens.policy_type = 'login-facebook'
  return axios
    .post(
      API_V3_ENDPOINT,
      {
        accessToken,
        email,
        nickname,
        platform,
        mktApp: true,
        session_ids: sessionTokens,
      },
      {
        headers: {
          'X-TestAB-Groups': abTests || '',
        },
        withCredentials: true,
      }
    )
    .then(response => {
      const { data } = response
      lastLoginStorage.saveFacebookLogin(data)
      return response
    })
}

export const facebookLoginApiValidation = (accessToken, email, nickname, sessionTokens) => {
  if (sessionTokens) sessionTokens.policy_type = 'login-facebook'
  return axios
    .post(
      API_V4_ENDPOINT,
      {
        accessToken,
        email,
        nickname,
        platform,
        mktApp: true,
        session_ids: sessionTokens,
      },
      { withCredentials: true }
    )
    .then(response => {
      const { data } = response
      lastLoginStorage.saveFacebookLogin(data)
      return response
    })
}
